import type { IScheduleState } from './types';

export const state: IScheduleState = {
  schedule: null,
  tests: null,
};
